import axios from "axios";
import router from "@/router";
import { useAuth } from "@/stores/auth";

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || "/api",
});

// Attach access token to every request
api.interceptors.request.use((config) => {
  const auth = useAuth();
  if (auth.token.value) {
    config.headers["Authorization"] = `Bearer ${auth.token.value}`;
  }
  return config;
});

// Handle 401 errors with refresh token
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const auth = useAuth();
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = localStorage.getItem("refresh_token");
      if (refreshToken) {
        try {
          const res = await axios.post(`${process.env.VUE_APP_API_URL || "/api"}/auth/refresh`, {
            refresh_token: refreshToken,
          });

          const { access_token, refresh_token } = res.data;

          // Update tokens in store & localStorage
          auth.login(access_token, refresh_token);

          // Retry original request with new access token
          originalRequest.headers["Authorization"] = `Bearer ${access_token}`;
          return api(originalRequest);
        } catch (err) {
          console.error("Refresh token invalid – logging out");
          auth.logout();
          router.push("/login");
          return Promise.reject(err);
        }
      } else {
        auth.logout();
        router.push("/login");
      }
    }

    return Promise.reject(error);
  }
);

export default api;
